import { Button, chakra, Text } from '@chakra-ui/react';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import moment from 'moment';
import AppCard from 'presentation/components/shared/card/AppCard';
import CardInfoRow from 'presentation/components/shared/card/CardInfoRow';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  asset: PeCompanyUserAsset;
  currency: Currency;
  onSellClick: () => void;
}

const PeDetailAssetCard: FC<Props> = ({ asset, currency, onSellClick, ...props }) => {
  const { t } = useTranslation();

  const currencyText = useCurrencyText();

  return (
    <AppCard pb="20px" px="20px" pt="15px" {...props}>
      <CardInfoRow label={t('openedPositionsTableCurrentPrice')}>
        <Text>
          {currencyText(asset.currentPrice, { symbol: currency.symbol })}
        </Text>
      </CardInfoRow>
      <CardInfoRow label={t('peSharesQuantity')}>
        <Text>{asset.quantity}</Text>
      </CardInfoRow>
      <CardInfoRow label={t('assetSum')}>
        <Text>
          {currencyText(asset.currentSum, { symbol: currency.symbol })}
        </Text>
      </CardInfoRow>
      <CardInfoRow label={t('dealStartedAt')}>
        <Text>{moment(asset.purchaseDate).format('DD.MM.yyyy')}</Text>
      </CardInfoRow>
      <CardInfoRow label={t('entryPrice')}>
        <Text>
          {currencyText(asset.purchasePrice, { symbol: currency.symbol })}
        </Text>
      </CardInfoRow>
      <CardInfoRow label={t('peActivePurchaseTotalAmount')}>
        <Text>
          {currencyText(asset.purchasePrice, { symbol: currency.symbol })}
        </Text>
      </CardInfoRow>
      <CardInfoRow label={t('peActiveRevenuePercent')} showBorder={false}>
        <Text
          color={
            asset.revenue.percent > 0
              ? Color.Profit
              : asset.revenue.percent < 0
              ? Color.Loss
              : Color.OnSurface
          }
        >
          {asset.revenue.percent.toFixed(2)}%
        </Text>
      </CardInfoRow>
      <Button w="full" mt="10px" onClick={onSellClick}>{t('sell')}</Button>
    </AppCard>
  );
};

export default chakra(PeDetailAssetCard);
